import { Layout, Typography,List, Avatar } from "antd";
import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";
import { ChatHistory } from "../../types/chats";
import { DATE_FORMAT } from "../../utils/const";
import dayjs from "dayjs";

const { Content } = Layout;
const { Title } = Typography;

export default function ChatPage() {
  const { id, uuid, sessionId } = useParams();
  const bottomRef = useRef<HTMLDivElement>(null);
  const [messages, setMessages] = useState<ChatHistory[]>([])

  useEffect(() => {
    const getData = async () => {
      try {
        const {data} = await axios.get(`${baseUrl}/chat_histories/get_messages/${sessionId}`,{
          params: {
            org_id: id,
            org_token: uuid
          }
        })
        setMessages(data)
      } catch (e){
        console.error(e)
      }
    }

    getData()
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages])

  return (
    <Layout style={{ background: "#f0f2f5", minHeight: "100vh", padding: "2rem" }}>
      <Content style={{ padding: "2rem", width: "100%" }}>
        <Title level={3}>Chat #{sessionId}</Title>

        <div
          style={{
            background: "#fff",
            padding: "1rem",
            borderRadius: "8px",
            overflowY: "auto",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            width: "100%",
            height: "80vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <List
            dataSource={messages}
            renderItem={(item) => (
              <List.Item
                style={{
                  justifyContent: item.message.type === "ai" ? "flex-end" : "flex-start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: item.message.type === "ai" ? "row-reverse" : "row",
                    maxWidth: "90%",
                  }}
                >
                  <Avatar src={item.message.type === "ai" ? "/assets/bot_icon.png" : "/assets/human_icon.png"} />
                  <div
                    style={{
                      backgroundColor: item.message.type === "ai" ? "#daf1da" : "#e6f4ff",
                      color: "#000",
                      padding: "10px",
                      borderRadius: "12px",
                      margin: "0 10px",
                      maxWidth: "90%",
                      wordBreak: "break-word",
                    }}
                  >
                    <div style={{ fontSize: 14 }}>{item.message.content}</div>
                    <div style={{ fontSize: 10, color: "#888", textAlign: "right" }}>
                      {dayjs(item.created_at).format(DATE_FORMAT)}
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
          <div ref={bottomRef} />
        </div>
      </Content>
    </Layout>
  );
}
